import type { Dictionnaire } from '../type';

export const auth: Dictionnaire['auth'] = {
  erreurs: {
    identifiants: 'Incorrect email or password',
    emailInvalide: 'Invalid email address',
    compteExiste: 'An account already exists with this email',
    motDePasseFaible: 'Password too weak',
    tropDeTentatives: 'Too many attempts, try again in a few minutes',
    reseau: "Can't connect, check your network",
    inattendue: 'Something went wrong, try again in a moment',
    parEmail: 'Sign in with your email address',
    age: 'Sirocco is for people aged 16 and over',
    pseudoPris: 'This username is already taken',
    sessionExpiree: 'Your session has expired, sign in again',
    motDePasseActuel: 'Current password is incorrect',
    sansProfil: "This account doesn't have a Sirocco profile yet. Contact us if the problem persists.",
    connexion: "Can't sign in",
  },
  champs: {
    email: 'Email address',
    exempleEmail: 'you@example.com',
    motDePasse: 'Password',
    retourConnexion: 'Back to sign in',
  },
  action: {
    incomplet: 'This link is incomplete.',
    expireNouveau: 'This link has expired or has already been used. Request a new one.',
    expire: 'This link has expired or has already been used.',
    sixCaracteres: 'At least six characters.',
    pasChange: "The password couldn't be changed. The link may have expired.",
    titreChange: 'PASSWORD CHANGED',
    titreNouveau: 'NEW PASSWORD',
    titreRetablie: 'ADDRESS RESTORED',
    titreConfirmee: 'ADDRESS CONFIRMED',
    unInstant: 'ONE MOMENT',
    nouveau: 'New password',
    changer: 'Change my password',
    connecteToi: 'You can now sign in with your new password.',
    bienvenue: 'Your account is open. Welcome.',
    ouvrir: 'Open Sirocco',
    continuerSite: 'Continue on the website',
    pour: { avant: 'Choose a new password for', apres: '.' },
  },
  spot: {
    impossible: "Can't join this server",
    publics: 'Public servers',
    prives: 'Private servers',
    bientot: 'Coming soon',
    tuEsMembre: "You're a member of this server",
    membre: 'Member of this server',
    badgePrive: 'Private',
    reserve: 'Members only',
    rechercher: 'Search for a city or region...',
    rechercherLabel: 'Search for a city or region',
    accesReserve: 'Members only',
    rejoindre: 'Join this server',
    membres: (n: number) => `${n.toLocaleString('en-GB')} member${n === 1 ? '' : 's'}`,
    aucun: (recherche: string) => `No server matches “${recherche}”`,
    prive: (nom: string) => `${nom} is a private server: only its members can enter.`,
  },
  confirmer: {
    titre: 'CONFIRM YOUR ADDRESS',
    renvoye: 'Email resent.',
    patiente: 'An email was just sent. Wait a minute before asking for another, and check your spam folder.',
    trop: 'Too many emails requested today. Try again tomorrow, or check your spam folder.',
    echec: "The email couldn't be sent. Try again.",
    renvoyer: 'Resend the email',
    deconnecter: 'Sign out',
    envoye: {
    avant: 'A confirmation email was sent to',
    apres: '. Tap the link inside to access the app.',
  },
  },
  oubli: {
    impossible: "Couldn't send",
    titre: 'PASSWORD',
    consigne: "Enter your email and we'll send you a reset link.",
    envoyer: 'Send the link',
    envoye: (email: string) => `If an account exists for ${email}, an email is on its way.`,
  },
  connexion: {
    impossible: "Can't sign in",
    oublie: 'Forgot your password?',
    seConnecter: 'Sign in',
    nouveau: 'New to Sirocco?',
    inscrire: 'Sign up',
  },
  personnaliser: {
    photoImpossible: "Couldn't save the photo",
    impossible: "Couldn't save",
    titre: 'Personalize your profile',
    choisirPhoto: 'Choose my profile photo',
    bio: 'Bio',
    bioExemple: "What you do here, what you're looking for, where you lived before...",
    continuer: 'Continue',
  },
  inscription: {
    regles: {
      huit: 'At least 8 characters',
      casse: 'Upper and lower case letters',
      chiffre: 'At least one number or special character',
    },
    manque: {
      prenom: 'Enter your first name',
      nom: 'Enter your last name',
      pseudo: 'Choose a username',
      email: 'Enter your email address',
      motDePasse: 'Choose a password',
      naissance: 'Enter your date of birth',
    },
    naissanceInvalide: 'Invalid date of birth',
    conditions: 'You must accept the terms of service',
    impossible: "Couldn't sign up",
    titre: 'SIGN UP',
    dejaInscrit: 'Already have an account?',
    seConnecter: 'Sign in',
    prenom: 'First name',
    nom: 'Last name',
    pseudo: 'Username',
    pseudoExemple: 'e.g. martin.pecheur',
    naissance: 'Date of birth',
    accepteLabel: "I accept Sirocco's terms of service and privacy policy",
    accepte: {
      debut: 'I accept the',
      cgu: 'terms of service',
      et: 'and the',
      confidentialite: 'privacy policy',
      fin: 'of Sirocco.',
    },
    langues: 'Languages you speak',
    languesAide: 'Outings in your languages come first in the list. You can change them in your profile.',
    jeMInscris: 'Sign me up',
  },
};
